import { useState, useRef, useCallback } from "react";
import { FaCheck, FaTimes, FaChevronDown } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import PortalDropdown from "./PortalDropdown";

const FamilyMemberRsvpDropdown = ({ member, memberIndex, onSelect }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClose = useCallback(() => setOpen(false), []);

    const getLabel = () => {
        if (member.attending === null || member.attending === undefined) {
            return { text: 'Na čekanju', color: 'text-gray-500', dot: 'bg-gray-400' };
        }
        if (member.attending === true) {
            return { text: 'Dolazi', color: 'text-green-700', dot: 'bg-green-500' };
        }
        return { text: 'Ne dolazi', color: 'text-red-600', dot: 'bg-red-400' };
    };

    const label = getLabel();

    return (
        <div ref={anchorRef}>
            <button
                onClick={() => setOpen(o => !o)}
                className="flex items-center justify-between gap-1.5 px-2 py-1 bg-white border border-gray-200 rounded-lg text-xs text-gray-700 hover:border-rose-300 hover:bg-rose-50 transition-all min-w-[110px]"
            >
                <span className="flex items-center gap-1.5">
                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${label.dot}`} />
                    <span className={`truncate font-medium ${label.color}`}>{label.text}</span>
                </span>
                <FaChevronDown className={`text-[10px] text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            <PortalDropdown anchorRef={anchorRef} open={open} onClose={handleClose}>
                <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden min-w-[160px]">
                    <button
                        onMouseDown={() => { onSelect(memberIndex, true); setOpen(false); }}
                        className={`w-full flex items-center gap-2 px-3 py-2 text-xs text-left hover:bg-green-50 transition border-b border-gray-50 ${member.attending === true ? 'font-semibold text-green-700 bg-green-50' : 'text-gray-700'}`}
                    >
                        <FaCheck className="text-green-500 text-[10px]" /> Dolazi
                    </button>
                    <button
                        onMouseDown={() => { onSelect(memberIndex, false); setOpen(false); }}
                        className={`w-full flex items-center gap-2 px-3 py-2 text-xs text-left hover:bg-red-50 transition border-b border-gray-50 ${member.attending === false ? 'font-semibold text-red-600 bg-red-50' : 'text-gray-700'}`}
                    >
                        <FaTimes className="text-red-500 text-[10px]" /> Ne dolazi
                    </button>
                    {member.attending !== null && member.attending !== undefined && (
                        <button
                            onMouseDown={() => { onSelect(memberIndex, null); setOpen(false); }}
                            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-left text-gray-400 hover:bg-gray-50 transition"
                        >
                            <FiX className="text-[10px]" /> Resetiraj
                        </button>
                    )}
                </div>
            </PortalDropdown>
        </div>
    );
};

export default FamilyMemberRsvpDropdown;
